import { defineMessage } from 'react-intl';

/** Messages for the Personas track chrome (density toggle, empty). */
export const personsTrackMessages = {
  lanes: defineMessage({
    id: 'logger.persons.track.lanes',
    defaultMessage: 'Ver por persona',
  }),
  collapse: defineMessage({
    id: 'logger.persons.track.collapse',
    defaultMessage: 'Compactar',
  }),
  empty: defineMessage({
    id: 'logger.persons.empty',
    defaultMessage: 'No se detectaron personas en este rango',
  }),
  unknown: defineMessage({
    id: 'logger.persons.unknown',
    defaultMessage: 'Persona no identificada',
  }),
};
